module.exports = __webpack_public_path__ + "media/images/flags/py-497ba378ee14ba60203bb2ba743a8c94.svg";